// The fragment is removed before application analytics initialize.
export function readResumeForm() {
  try {
    const saved = JSON.parse(sessionStorage.getItem('quote_resume_form'));
    if (!saved || saved.expires <= Date.now() || !saved.form) return null;
    const poolType = typeof saved.form.poolType === 'string'
      ? saved.form.poolType.trim().toLowerCase()
      : saved.form.poolType;
    return { ...saved.form, poolType };
  } catch { return null; }
}

export function firstMissingResumeSlide(form) {
  if (!form.personName || !form.phone || !form.address || !form.zipCode) return 'contact';
  if (!form.poolType) return 'type';
  if (!form.service?.length) return 'service';
  if (form.service.includes('regular_pool_spa_service') && !form.poolCondition) return 'condition';
  if (form.service.includes('equipment_repair') && !form.poolHelp?.length) return 'equipment';
  if (form.service.includes('greentoclean')) return 'g2c-contact';
  if (!form.poolOption) return 'features';
  if (['pool_only', 'pool_spa', 'pool_hot_tub', 'something_else'].includes(form.poolOption)) {
    if (!Array.isArray(form.poolOption1)) return 'environment';
    if (form.poolOption1.includes('ground_pool')) return 'above-ground-contact';
    if (!['small', 'medium', 'large'].includes(form.poolSize)) return 'size';
  }
  return 'final-contact';
}
